import { useEffect, useState } from "react";
import downArrow from "../../../../assets/svg/downarrow.svg";
import upArrow from "../../../../assets/svg/uparrow.svg";
import "../../documents/folder/folder.css";
import moment from "moment";
import search from "../../../../assets/svg/searchmaxicon.svg";
import url from "../../../../assets/svg/url.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import "./searchResult.css";
import { PulseLoader } from "react-spinners";
import {
  GET_FILES_URL,
  POST_SEARCH_DETAILS,
} from "../../../../helpers/endpointService";
import "react-toastify/dist/ReactToastify.css";
import FileIcon from "../../documents/folder/FileIcon";
import { useNavigate } from "react-router";
import PaginationComponent from "../../documents/Pagination";
import formats from "../../../../helpers/MediaFormats";
import VideoPop from "../VideoPop";
import AudioPopup from "../AudioPop";
import {
  searchDataStore,
  searchResultStore,
  searchStateFn,
} from "../../../../redux/action/Action";
import { logoutFunction } from "../../../custom/commonFunction";
import Filter from "../../../../assets/svg/filter.svg";
import * as paths from "../../../../helpers/routerPaths";
import {
  rightBarClose,
  rightBarOpen,
  setPendingCountFn,
} from "../../../../redux/action/Action";
import {
  NEW_DOCUMENT,
  UPLOAD_DOCUMENT,
  NOTIFICATIONS,
  SEARCH_BAR,
} from "../../../../helpers/Rightbar_action";

var sortName = "publishedDate";
var sortOrder = "asc";

export default function SearchResult() {
  const userId = localStorage.getItem("UserId");
  const userRole = localStorage.getItem("Role");
  // const {
  //   rightbarOpen,
  //   rightbarType,
  //   pendingCount,
  //   searchState,
  //   notifyCountState,
  // } = useSelector((state) => ({
  //   rightbarOpen: state.documentReducer.rightbarOpen,
  //   rightbarType: state.documentReducer.rightbarType,
  //   pendingCount: state.documentReducer.pendingCount,
  //   searchState: state.documentReducer.searchState,
  //   notifyCountState: state.documentReducer.notifyCount,
  // }));

  const nav = useNavigate();
  const dispatch = useDispatch();

  let { menuToggle } = useSelector((state) => ({
    menuToggle: state.commonReducer.menuToggle,
  }));

  const { searchParameters, previousResults, trigger } = useSelector(
    (state) => ({
      searchParameters: state.documentReducer.searchData,
      previousResults: state.documentReducer.searchResult,
      trigger: state.documentReducer.searchTrigger,
    })
  );

  var { searchState, rightbarOpen } = useSelector((state) => ({
    searchState: state.documentReducer.searchState,
    rightbarOpen: state.documentReducer.rightbarOpen,
  }));

  const [pageCount, setPageCount] = useState(1);
  // const [searchData, setSearchData] = useState()
  const [isLoader, setLoader] = useState(false);
  const [isPlayVideo, setPlayVideo] = useState(false);
  const [isPlayAudio, setPlayAudio] = useState(false);
  const [videoSrc, setVideoSrc] = useState();
  const [audioSrc, setAudioSrc] = useState("");
  const [searchResults, setSearchResults] = useState();
  const [isMobile, setisMobile] = useState(false);
  const [isfetch, setIsfetch] = useState(false);
  const [isSmallMobile, setisSmallMobile] = useState(false);
  const [isRadioMobile, setisRadioMobile] = useState(false);
  const navigate = useNavigate();

  /*  const [sortName, setSortName] = useState('');
  const [sortOrder, setSortOrder] = useState("asc"); */

  // useEffect(()=> {
  //     setSearchData(searchResult)
  // },[searchResult])

  useEffect(() => {
    const intervals = setInterval(() => {
      resize();
    }, 10);
    return () => clearInterval(intervals);
  }, []);

  const resize = () => {
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }
    if (window.innerWidth < 750) {
      setisSmallMobile(true);
    } else {
      setisSmallMobile(false);
    }
    if (window.innerWidth < 490) {
      setisRadioMobile(true);
    } else {
      setisRadioMobile(false);
    }
  };

  const fetchData = async (currentPage, perPage) => {
    if (isfetch === true) {
      setIsfetch(true);
      setLoader(true);
      const newData = { ...searchParameters };
      newData.pageNumber = currentPage || 1;
      newData.pageSize = perPage || 20;
      let order = sortOrder === "asc" ? true : false;
      axios({
        method: "POST",
        url: `${POST_SEARCH_DETAILS}?userId=${userId}&sortBy=${sortName}&isSortAscending=${order}`,
        data: newData,
      })
        .then((response) => {
          setLoader(false);
          if (response?.status === 200) {
            setSearchResults(response.data);
            dispatch(searchResultStore(response.data));
            dispatch(searchStateFn(true));

            // dispatch(searchResultStore(response.data))
          }
        })
        .catch((err) => {
          setLoader(false);

          logoutFunction(err?.response?.status);
        });
    } else {
      setIsfetch(true);
      setSearchResults();
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchParameters, trigger]);

  useEffect(() => {
    // dispatch(searchDataStore({}));

    return () => {
      dispatch(searchDataStore({}));
    };
  }, []);

  /* useEffect(()=>{
  console.log(searchState)
},[searchState]) */

  /////////////////////////////////// File open ///////////////////////////////////

  const handleFileOpen = (id, type) => {
    if (id) {
      setLoader(true);

      let fileUrl = null;
      const fetchFileUrl = async () => {
        let fileSrcUrl = `${GET_FILES_URL}?fileId=${id}`;
        await axios
          .get(fileSrcUrl)
          .then((response) => {
            if (response?.status === 200) {
              fileUrl = response.data;
              setLoader(false);
              if (fileUrl) {
                const fileType =
                  type === "url" ? type : fileUrl.split(".").pop();
                const supportedFormats = Object.values(formats).flat();

                if (supportedFormats.includes(fileType)) {
                  const findKeyByValue = (value, obj) => {
                    for (let key in obj) {
                      if (obj[key].includes(value)) {
                        return key;
                      }
                    }
                    return null;
                  };

                  const fileTypeKey = findKeyByValue(fileType, formats);

                  if (fileTypeKey) {
                    switch (fileTypeKey) {
                      case "video":
                        setPlayVideo(true);
                        setVideoSrc(fileUrl);
                        break;
                      case "audio":
                        setPlayAudio(true);
                        setAudioSrc(fileUrl);
                        break;
                      case "word":
                      case "pdf":
                      case "ppt":
                      case "zip":
                      case "xlsx":
                      case "image":
                      case "url":
                        window.open(fileUrl);
                        break;
                      default:
                        console.error(`Unsupported file type: ${fileType}`);
                    }
                    return;
                  } else {
                    console.error(`Unsupported file type: ${fileType}`);
                  }
                } else {
                  console.error(`Unsupported file type: ${fileType}`);
                }
              }
            }
          })
          .catch((err) => {
            setLoader(false);

            logoutFunction(err?.response?.status);
          });
      };
      fetchFileUrl();
    }
  };

  ////////////////////////////////////////  Media popup close /////////////////////////////////
  const handleCloseModal = () => {
    setPlayAudio(false);
    setPlayVideo(false);
  };

  ///////////////////////////////////// Sort table ////////////////////////////////

  /*  const sortTable = name => {
  const sortedData = [...searchResults?.values];

  let order = sortOrder;

  if(sortName === name) {

    if(sortOrder === "dec"){ 
        order = "asc"
      setSortOrder(order)
    }
    else { 
        order = "dec"
      setSortOrder(order)
    }
  }

  setSortName(name)
  
  sortedData.sort((a, b) => {
    const valueA = a[name];
    const valueB = b[name];
  if (name === "assignedDate" || name === "publishedDate"||name==="reviewDate"||name==="requestedDate")  {
      const dateA = new Date(a[name]); 
      const dateB = new Date(b[name]);
  
      if (order === 'asc') {
        return dateA.getTime() - dateB.getTime();
      } else {
        return dateB.getTime() - dateA.getTime();
      }
    }
      else if (typeof valueA === 'number' && typeof valueB === 'number') {

      if (order === 'asc') {
        return valueA - valueB;
      } else {
        return valueB - valueA;
     }

    } else {
        if (order === 'asc') {
          return (valueA ??" ").localeCompare(valueB? valueB:"");
          } else {
            return (valueB ??" ").localeCompare(valueA? valueA:"");
          }
      }
  });
    setSearchResults({ ...searchResults, values: sortedData }); 
}; */

  const sortTable = (name) => {
    let order = sortOrder;
    if (sortName === name) {
      sortName = name;
      if (sortOrder === "asc") {
        sortOrder = "desc";
      } else {
        sortOrder = "asc";
      }
    } else {
      sortName = name;
      sortOrder = "asc";
    }
    dispatch(searchStateFn(false));
    searchState = false;
    sortbyFormat();
  };

  const sortbyFormat = () => {
    /*   const timer = setTimeout(() => { */
    fetchData();
  };

  const OpenPendingSearch = () => {
    navigate(`/${paths.SEARCH}`);
    dispatch(rightBarOpen(SEARCH_BAR)); //Ashwin
  };

  /* }, 500); */

  return (
    <>
      {isLoader && (
        <div className="spinner_overlay">
          <div className="loader">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        </div>
      )}

      <div
        className={
          isMobile
            ? "search-container-mob search"
            : !menuToggle
            ? `search-container-open search`
            : `search-container search`
        }
      >
        <div className="titleContainer">
          <div className="title">
            <img src={search} />
            <span>Search results</span>
          </div>
          <div
            className={`${
              isMobile
                ? "mobile-search"
                : menuToggle
                ? " sidemenu-search"
                : "web-search"
            }`}
          >
            <table width="100%">
              <tbody>
                <tr>
                  <td width="90%">
                  {searchResults ? (
            <div className="category" style={{ border: "none" }}>
              {searchResults ? (
                <span className="catActive docFound">
                  {searchResults?.totalCount === 0 || !searchResults
                    ? "No document found"
                    : searchResults?.totalCount === 1
                    ? "1 document found"
                    : `${searchResults?.totalCount} documents found`}
                </span>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}
                  </td>
                  <td width="10%" className="text-end">
                    <button
                      className={`displaybutton ${
                        isRadioMobile ? "pr-1" : ""
                      } ${isSmallMobile ? "pl-0" : ""}`}
                      id="displaybuttoncolor"
                      onClick={() => OpenPendingSearch()}
                    >
                      <img src={Filter} style={{ marginTop: "-4px" }}></img>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* {searchResults ? (
            <div className="category" style={{ border: "none" }}>
              {searchResults ? (
                <span className="catActive docFound">
                  {searchResults?.totalCount === 0 || !searchResults
                    ? "No document found"
                    : searchResults?.totalCount === 1
                    ? "1 document found"
                    : `${searchResults?.totalCount} documents found`}
                </span>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )} */}
        </div>
        {searchResults?.values?.length > 0 ? (
          <>
            <div
              className={`${
                isMobile ? "pending-mobile-table " : "pending-table1 "
              } table-responsive fileList2  table-fixed-header table-responsive-height`}
              style={{ marginTop: window.innerWidth < 850 ? "110px" : "134px" }}
            >
              <table className="table fileListTable2 table-borderless table-hover">
                <thead className="thead-sticky  thead-color">
                  <tr>
                    <td></td>
                    <td
                      style={{ display: "flex" }}
                      className="cursor-pointer"
                      onClick={() => sortTable("documentNo")}
                    >
                      <span>Document no. </span>
                      {sortName === "documentNo" && (
                        <img
                          src={sortOrder === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("documentName")}
                    >
                      <span>Document name</span>
                      {sortName === "documentName" && (
                        <img
                          src={sortOrder === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("fileName")}
                    >
                      <span>File name</span>
                      {sortName === "fileName" && (
                        <img
                          src={sortOrder === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("authorName")}
                    >
                      <span>Author</span>
                      {sortName === "authorName" && (
                        <img
                          src={sortOrder === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("category1Name")}
                    >
                      <span>Category 1</span>
                      {sortName === "category1Name" && (
                        <img
                          src={sortOrder === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("category2Name")}
                    >
                      <span>Category 2</span>
                      {sortName === "category2Name" && (
                        <img
                          src={sortOrder === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                    {userRole === "Admin" && (
                      <td>
                        <span>Status</span>
                      </td>
                    )}
                    <td
                      className="cursor-pointer"
                      onClick={() => sortTable("publishedDate")}
                    >
                      <span>Published date/time</span>
                      {sortName === "publishedDate" && (
                        <img
                          src={sortOrder === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                  </tr>
                </thead>

                <tbody>
                  {searchResults?.values?.map((list, index) => {
                    return (
                      <tr key={index}>
                        <td></td>
                        <td style={{ display: "flex" }}>
                          <span
                            onClick={() =>
                              nav(
                                `/documents/${list.category1Id}/${list.category2Id}/${list.documentId}/`
                              )
                            }
                            className="fileName tableoverflowNo"
                            title={list.documentNo}
                            style={{ color: "blue" }}
                          >
                            {list.documentNo}
                          </span>
                        </td>
                        <td>
                          <span
                            className="tableoverflowNo"
                            title={list.documentName}
                          >
                            {list.documentName}
                          </span>
                        </td>
                        <td style={{ display: "flex" }} title={list.fileName}>
                          <div style={{ paddingRight: "10px" }}>
                            {list.fileType === "url" ? (
                              <img src={url} alt="" />
                            ) : (
                              <FileIcon fileName={list.fileName} />
                            )}
                          </div>
                          <span
                            className="fileName tablefilename"
                            title={list.fileName}
                            onClick={() =>
                              handleFileOpen(list.fileId, list.fileType)
                            }
                          >
                            {list.fileName}
                          </span>
                        </td>
                        <td>
                          <span
                            className="tableoverflow1"
                            title={list.authorName}
                          >
                            {list.authorName}
                          </span>
                        </td>
                        <td>
                          <span
                            className="tableoverflow1"
                            title={list.category1Name}
                          >
                            {list.category1Name}
                          </span>
                        </td>
                        <td>
                          <span
                            className="tableoverflow1"
                            title={list.category2Name}
                          >
                            {list.category2Name}
                          </span>
                        </td>
                        {userRole === "Admin" && (
                          <td>
                            <span
                              style={{
                                color:
                                  list.documentStatus.toLowerCase() === "active"
                                    ? "#21A366"
                                    : list.documentStatus.toLowerCase() ===
                                      "obsolete"
                                    ? "#D12232"
                                    : "#FF9000",
                                fontWeight: "600",
                              }}
                              className="tableoverflow1"
                              title={list.documentStatus}
                            >
                              {list.documentStatus}
                            </span>
                          </td>
                        )}
                        <td>
                          <span className="tableoverflowDate">
                            {" "}
                            {list.publishedDate
                              ? moment(
                                  new Date(Date.parse(list.publishedDate))
                                ).format("DD-MMM-YYYY h:mm a")
                              : ""}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {(searchResults?.values).length && (
              <>
                <PaginationComponent
                  fetchPagination={fetchData}
                  pageCount={searchResults.totalCount}
                />
              </>
            )}

            {isPlayVideo && (
              <VideoPop videoUrl={videoSrc} onClose={handleCloseModal} />
            )}

            {isPlayAudio && (
              <AudioPopup audioUrl={audioSrc} onClose={handleCloseModal} />
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
